import { render, staticRenderFns } from "./AttorneyFileUploadPop.vue?vue&type=template&id=50a06f90&scoped=true"
import script from "./AttorneyFileUploadPop.vue?vue&type=script&lang=js"
export * from "./AttorneyFileUploadPop.vue?vue&type=script&lang=js"
import style0 from "./AttorneyFileUploadPop.vue?vue&type=style&index=0&id=50a06f90&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a06f90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50a06f90')) {
      api.createRecord('50a06f90', component.options)
    } else {
      api.reload('50a06f90', component.options)
    }
    module.hot.accept("./AttorneyFileUploadPop.vue?vue&type=template&id=50a06f90&scoped=true", function () {
      api.rerender('50a06f90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/AttorneyFileUploadPop.vue"
export default component.exports